export default __webpack_public_path__ + "static/form-default-values-do-c794b528748dbc65c85b62df3ad98052.png";